import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    flexInput: { margin: theme.spacing(1), flex: 1 },
    indicatorContainer: {
        margin: theme.spacing(0, 1, 1, 1),
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(0.5),
    },
    rewardsChip: {
        alignSelf: "flex-start",
        borderRadius: 8,
        color: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
    },
    pendingText: {
        color: theme.palette.text.secondary,
    },
    pendingEmail: {
        color: theme.palette.primary.main,
    },
    errorText: {
        color: theme.palette.error.main,
    },
    oneParkSubmitBtn: {
        alignSelf: "flex-start",
        marginTop: theme.spacing(0.5),
    },
    dialogField: {
        marginTop: theme.spacing(1),
    },
    currentEmailLabel: {
        color: theme.palette.text.secondary,
    },
    currentEmailValue: {
        color: theme.palette.text.primary,
        wordBreak: "break-all",
    },
    dialogError: {
        marginTop: theme.spacing(1),
        color: theme.palette.error.main,
    },
    backdrop: {
        background: "rgba(0, 0, 0, 0.65)",
        backdropFilter: "blur(4px)",
    },
}));
